export class SiloPropriedadeModel {
  capacidade_estoque: number;
  estoque_estimado: number;
  estoque_informado: number;
}